import data from '@iez/lib/data/'
import { computed } from '@vue/composition-api'

const userWithPhoneNumber = data.me({
  fields: [
    `id`,
    `phoneNumber`
  ],
  realtime: true,
  isCalledFromComponent: false
})

console.log(userWithPhoneNumber)

export default computed(
  () =>
    userWithPhoneNumber.value?.phoneNumber === `+33600000000` ||
    ![`+336`, `+337`].some(
      allowedPrefix =>
        userWithPhoneNumber.value?.phoneNumber.startsWith(allowedPrefix)
    )
    
)
